export default __webpack_public_path__ + "static/media/resume.32ebbc59.pdf";